<app-modal-v2 #modal customClassName="diary-config-modal">
  <div class="modal-content">

    <div class="modal-header">
      <div class="title-culture-container">
        <h2 class="modal-title">E-Diary Configuration</h2>

        <div class="culture-select">
          <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
        </div>
      </div>

    </div>
    <div class="modal-body">
      <!-- Start: Internal name -->
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Internal E-Diary Name <sup>*</sup></label>
              <input type="text" formControlName="name" class="form-control" placeholder="Enter internal e-diary name...">
            </div>
            <div class="form-group">
              <label>Type</label>
              <div class="fake-field disabled">{{ diaryTypeLabel }}</div>
            </div>
          </div>
        </div>
      </form>
      <!-- End: Internal name -->

      <!-- Start: Custom title -->
      <form [formGroup]="form">
        <div class="checkbox-toggle">
          <div class="checkbox-wrap">
            <label class="checkbox" [class.checked]="form.value.overrideTitle">
              <input type="checkbox" id="overrideTitle" formControlName="overrideTitle" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="overrideTitle">
              Custom E-Diary Title
              <span class="checkbox-note">If left unchecked the default 'eDiary' will be used.</span>
            </label>
          </div>
        </div>
      </form>

      <div class="custom-title-container" [class.visibility-hidden]="!form.value.overrideTitle">
        <ng-container *ngFor="let cultureForm of cultureForms">
          <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
            <div class="row" [class.visibility-hidden]="!form.value.overrideTitle">
              <div class="col-12">
                <div class="form-group">
                  <label>Custom E-Diary Title <sup>*</sup></label>
                  <input type="text" formControlName="customTitle" class="form-control" placeholder="Enter a custom e-diary title...">
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
      <!-- End: Custom title -->

      <!-- Start: Custom completed title -->
      <ng-container *ngIf="diaryForm?.diaryType !== DiaryType.OnboardingQuestions">
        <form [formGroup]="form">
          <div class="checkbox-toggle">
            <div class="checkbox-wrap">
              <label class="checkbox" [class.checked]="form.value.overrideCompletedTitle">
                <input type="checkbox" id="overrideCompletedTitle" formControlName="overrideCompletedTitle" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="overrideCompletedTitle">
                Custom E-Diary Completed Title
                <span class="checkbox-note">If left unchecked the default 'eDiary completed at XX:XX' will be used.</span>
              </label>
            </div>
          </div>
        </form>

        <div class="custom-title-container" [class.visibility-hidden]="!form.value.overrideCompletedTitle">
          <ng-container *ngFor="let cultureForm of cultureForms">
              <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
                <div class="row" [class.visibility-hidden]="!form.value.overrideCompletedTitle">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Custom E-Diary Completed Title <sup>*</sup></label>
                      <input type="text" formControlName="completedTitle" class="form-control" placeholder="Enter a custom e-diary completed title...">
                    </div>
                  </div>
                </div>
              </form>
          </ng-container>
        </div>
      </ng-container>
      <!-- End: Custom completed title -->

      <form [formGroup]="form">
        <div class="row" *ngIf="diaryForm?.diaryType !== DiaryType.IntraDay && diaryForm?.diaryType !== DiaryType.OnboardingQuestions">
          <div class="col-6">
            <div class="form-group">
              <label>Frequency</label>
              <div class="fake-field disabled" *ngIf="form.value.selectedCulture !== 'en'">{{ getFrequencyText() }}</div>
              <app-input-select controlName="frequencyType" [parentForm]="form" [items]="freqOptions" [class.visibility-hidden]="form.value.selectedCulture !== 'en'" />
            </div>
          </div>

          @if (form.value.frequencyType === '3' || form.value.frequencyType === '4') {
            <div class="col-6">
              <div class="form-group">
                <label>{{ form.value.frequencyType === '3' ? 'Days between entries' : 'Weeks between entries' }}</label>
                <div class="fake-field disabled" *ngIf="form.value.selectedCulture !== 'en'">{{ form.value.frequencyInterval }}</div>
                <input type="number" min="1" formControlName="frequencyInterval" class="form-control" [class.visibility-hidden]="form.value.selectedCulture !== 'en'">
              </div>
            </div>
          }
        </div>

        <div class="row" *ngIf="diaryForm?.diaryType !== DiaryType.IntraDay">
          <div class="col-6">
            <div class="form-group">
              <label>Notification Frequency</label>
              <div class="fake-field disabled">On the day</div>
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <label>Default Patient Reminder Time</label>
              <div class="fake-field disabled" *ngIf="form.value.selectedCulture !== 'en'">{{ form.value.defaultReminderTime }}</div>
              <app-input-timepicker formControlName="defaultReminderTime" [class.visibility-hidden]="form.value.selectedCulture !== 'en'"></app-input-timepicker>
            </div>
          </div>
        </div>

        @if (diaryForm?.diaryType === DiaryType.IntraDay) {
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Default Patient Reminder Times</label>
                <div class="on-demand-reminder-times">
                  @for (t of defaultIntraDayReminderTimes; track t) {
                    <div class="on-demand-reminder-time-row">
                      <span class="on-demand-reminder-time-value">{{ formatReminderTime(t) }}</span>
                      <button type="button" class="on-demand-reminder-remove-btn" (click)="removeDefaultReminderTime(t)" title="Remove">
                        <i class="far fa-times"></i>
                      </button>
                    </div>
                  }
                  @if (defaultIntraDayReminderTimes.length === 0) {
                    <p class="text-muted" style="font-size:0.85rem;margin:8px 0 0 0;">No reminder times configured.</p>
                  }
                </div>
                <div class="on-demand-add-row">
                  <div class="input-wrap type-time">
                    <mat-form-field>
                      <input type="time" matInput formControlName="newIntraDayReminderTime">
                    </mat-form-field>
                  </div>
                  <button type="button" class="btn btn-outline btn-outline-slim" (click)="addDefaultReminderTime()" [disabled]="!form.get('newIntraDayReminderTime').value">Add</button>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Start: Mandatory notification toggle -->
        <div class="checkbox-toggle">
          <div class="checkbox-wrap">
            <label class="checkbox" [class.checked]="form.value.mandatoryNotification">
              <input type="checkbox" id="mandatoryNotification" formControlName="mandatoryNotification" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="mandatoryNotification">
              Mandatory Notification
              <span class="checkbox-note">This notification must be sent and cannot be disabled by patients.</span>
            </label>
          </div>
        </div>
        <!-- End: Mandatory notification toggle -->
      </form>

      <ng-container *ngFor="let cultureForm of cultureForms">
        <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Reminder Notification Title</label>
                <input type="text" formControlName="title" class="form-control" placeholder="Enter notification title...">
              </div>

              <div class="form-group">
                <label>Reminder Notification Text</label>
                <textarea formControlName="text" class="form-control" placeholder="Enter notification text..."></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>
                  Email Notification Subject
                  @if (isControlRequired(cultureForm.get('emailSubject'))) {
                    <sup>*</sup>
                  }
                </label>
                <input type="text" formControlName="emailSubject" class="form-control" placeholder="Enter email notification title...">
              </div>

              <div class="form-group">
                <label>
                  Email Notification Body
                  @if (isControlRequired(cultureForm.get('emailBody'))) {
                    <sup>*</sup>
                  }
                </label>
                <textarea formControlName="emailBody" class="form-control" placeholder="Enter email notification text..."></textarea>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </div>

    <div class="modal-footer">
      <div class="modal-footer-buttons">
        <app-button text="Cancel" variant="secondary" width="fill"
                    type="button" (click)="hide()" />

        <app-button text="Apply" [disabled]="!isFormValid()" variant="primary" width="fill"
                    type="button" (clicked)="onApply()" />
      </div>
    </div>

  </div>
</app-modal-v2>
